module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_sola_black-9310322754df88c0e6489dbb7237d0c9.svg";